import { render, staticRenderFns } from "./CreateMaterialsRequests.vue?vue&type=template&id=7015fa96&"
import script from "./CreateMaterialsRequests.vue?vue&type=script&lang=js&"
export * from "./CreateMaterialsRequests.vue?vue&type=script&lang=js&"
import style0 from "./CreateMaterialsRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7015fa96')) {
      api.createRecord('7015fa96', component.options)
    } else {
      api.reload('7015fa96', component.options)
    }
    module.hot.accept("./CreateMaterialsRequests.vue?vue&type=template&id=7015fa96&", function () {
      api.rerender('7015fa96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/components/CreateMaterialsRequests.vue"
export default component.exports